module.exports = __webpack_public_path__ + "static/media/NEW_LABEL_CONFIRMED.10d8d188.svg";